import { CaptionStyles, CaptionLineConfig, HighlightTypeEnum } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const sign: Partial<CaptionStyles> = {
  theme_preset: 'sign',
  pageStyle: {
    color: '#000000'
  },
  wordStyle: {
    inactive: {
      color: '#000000'
    },
    highlightType: HighlightTypeEnum.Box,
    highlightBoxStyle: {
      background: '#ffff00',
      borderRadius: '15px',
      inset: '-10px -20px'
    }
  },
  letterStyle: undefined,
  font_location: getFontFullPath('Oswald-Bold.ttf'),
  caps: true,
  line_config: CaptionLineConfig.OneWord,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default sign;
